export interface WebUserModel {
  email: string;
  firstName: string;
  lastName: string;
  title: string;
  userName: string;
  newPassword?: string;
  customerId: string;
  companyUserId: number;
  active: boolean;
  hasSmartConnectProfile: boolean;
  submit?: null;
}

export const defaultWebUserModel: WebUserModel = {
  email: '',
  firstName: '',
  lastName: '',
  title: '',
  userName: '',
  customerId: '',
  companyUserId: 0,
  active: false,
  hasSmartConnectProfile: false,
};
